import sdk from '../../sdk';
import prepareSearchQuery from '../assets/prepareSearchQuery';

export const PAGE_SIZE = 50;

export default function searchMain(page, sort, extras = {}) {
  const data = {
    ...prepareSearchQuery(),
    ...extras,
    size: PAGE_SIZE,
    from: (page - 1) * PAGE_SIZE,
    sort,
  };

  // Pinned operation ids already identify the rows; listingStatus in ES can lag
  // behind the Mongo write and empty the grid.
  if (data.ids) delete data.listingStatus;

  return sdk.products.search(data);
}
